import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import {
  setLoadingPaymentMethods,
  setLoadingPaymentMethod,
  setLoadingPaymentMethodCreate,
  setLoadingPaymentMethodUpdate,
  setLoadingPaymentMethodDelete,
  setErrorLoadingPaymentMethods,
  setErrorLoadingPaymentMethod,
  setErrorCreatingPaymentMethod,
  setErrorUpdatingPaymentMethod,
  setErrorDeletingPaymentMethod,
  setPaymentMethods,
  setPaymentMethod,
  createPaymentMethodSuccess,
  updatePaymentMethodSuccess,
  deletePaymentMethodSuccess,
  setServerResponseStatus,
} from "../slices/paymentMethod";
import { getErrorMessage } from "../../utils/errorUtils";

export const getPaymentMethods = () => async (dispatch) => {
  dispatch(setLoadingPaymentMethods());

  try {
    const { data } = await axiosInstance.get("/payment-methods", {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setPaymentMethods(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingPaymentMethods(getErrorMessage(error)));
  }
};

export const getPaymentMethodById = (id) => async (dispatch) => {
  dispatch(setLoadingPaymentMethod());

  try {
    const { data } = await axiosInstance.get(`/payment-methods/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setPaymentMethod(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingPaymentMethod(getErrorMessage(error)));
  }
};

export const createPaymentMethod = (values) => async (dispatch) => {
  dispatch(setLoadingPaymentMethodCreate());

  try {
    const { data } = await axiosInstance.post("/payment-methods", values, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "PaymentMethod created successfully!");
      dispatch(createPaymentMethodSuccess(data.data));
      dispatch(
        setServerResponseStatus({
          operation: "create",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorCreatingPaymentMethod(message));
  }
};

export const updatePaymentMethod =
  ({ id, values }) =>
  async (dispatch) => {
    dispatch(setLoadingPaymentMethodUpdate());

    try {
      const { data } = await axiosInstance.put(
        `/payment-methods/${id}`,
        values,
        {
          headers: { requiresAuth: true },
        },
      );

      if (data.status === "SUCCESS") {
        toast.success(data.message || "PaymentMethod updated successfully!");
        dispatch(updatePaymentMethodSuccess(data.data));
        dispatch(
          setServerResponseStatus({
            operation: "update",
            status: data.statusCode,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(setErrorUpdatingPaymentMethod(message));
    }
  };

export const deletePaymentMethod = (id) => async (dispatch) => {
  dispatch(setLoadingPaymentMethodDelete());

  try {
    const { data } = await axiosInstance.delete(`/payment-methods/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "PaymentMethod deleted successfully!");
      dispatch(deletePaymentMethodSuccess(id));
      dispatch(
        setServerResponseStatus({
          operation: "delete",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorDeletingPaymentMethod(message));
  }
};

export const resetPaymentMethodServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
